import styled from 'styled-components'

export const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grey};
  height: auto;
  .mb {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    .mb {
      display: flex;
    }
    .lg {
      display: none;
    }
  }
  .top-bar {
    margin-top: 15px;
  }
  .menu-bars {
    font-size: 2rem;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      position: absolute;
      left: 15px;
      top: 5px;
    }
  }
  .icons {
    font-size: 20px;
  }
  .navbar {
    display: none;
    justify-content: start;
    align-items: center;
    margin: 18px 0px;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      position: relative;
      margin: 0px 0px;
      display: flex;
    }
  }

  .nav-menu {
    background-color: ${({ theme }) => theme.colors.sideBar};
    width: 240px;
    height: 100vh;
    display: flex;
    z-index: 0;
    justify-content: center;
    position: fixed;
    top: 0;
    left: -100%;
    transition: 850ms;
  }
  .nav-menu-items {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }

  .nav-menu.activer {
    left: 0;
    transition: 350ms;
  }
  .active-class {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100vw;
      position: fixed;
      top: 0;
      background-color: rgba(0, 0, 0, 0.3);
      right: 0;
      left: 0;
      height: 100vh;
      z-index: 12;
    }
  }
  .nav-text {
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-weight: 400;
    display: flex;
    justify-content: start;
    align-items: center;
    list-style: none;
    height: 48px;
    margin-left: -25px;
    text-decoration: none;
    width: 90%;
    padding-left: 20px;
    font-size: ${({ theme }) => theme.fontSize.x5};
    margin-top: 5px;
    /* border-radius: 10px; */
    color: ${({ theme }) => theme.colors.resetColor};
  }
  .nav-text:hover {
    /* background-color: ${({ theme }) => theme.colors.Transgrey}; */
    background: rgba(87, 102, 255, 0.1);
  }

  .navbar-toggle {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-left: -23px;
    margin-top: -20px;
    margin-right: 20px;
  }

  span {
    margin-left: 12px;
  }
  .logo {
    width: 71.8%;
    margin-top: 14px;
    margin-bottom: 20px;
  }
  .download {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: -40px;
  }
  .downloadp {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #4f4f4f;
    margin-top: -5px;
  }
  .hamClose {
    display: flex;
    align-items: center;
    margin-left: -10px;
  }
  .hamimgOpen {
    width: 24px;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      margin-top: 10px;
      width: 40px;
    }
  }
  .hamimgClose {
    width: 24px;
    position: absolute;
    left: -10px;
    top: 25px;
  }
  .imgDownload {
    width: 60%;
  }
  .active {
    color: ${({ theme }) => theme.colors.primary};
    background: rgba(87, 102, 255, 0.1);
    border-left: 3px solid blue;
    font-weight: 400;
  }

  @media (min-width: 768px) and (max-width: 1500px) {
    .nav-menu {
      left: 0;
    }
    .menu-bars {
      display: none;
    }
    .navbar-toggle {
      background-color: transparent;
      height: 0px;
    }
    .navbar {
      display: none;
    }
  }
`

export const Profiler = styled.div`
  display: flex;
  align-items: center;
  /* padding-right: 35px; */
  padding-top: 10px;

  .help {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .picture-width {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  .alert {
    margin-left: 20px;
    margin-top: 5px;
    cursor: pointer;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      margin-left: 38px;
    }
  }
  .picture {
    cursor: pointer;
    margin-left: 20px;
    display: flex;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      margin-left: 30px;
    }
  }
  .pictureDesc {
    margin-left: 7px;
    margin-right: 3px;
    color: ${({ theme }) => theme.colors.dark};
  }
  .helpDesc {
    margin-left: 14px;
    color: ${({ theme }) => theme.colors.dark};
  }
  a {
    text-decoration: none;
  }

  .pictureimg {
    margin: 0 10px;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    margin-top: 20px;
    padding-top: 0px;
    padding-right: 17px;
    .pictureDesc {
      display: none;
    }
    .helpDesc {
      display: none;
    }
    .pictureimg {
      display: none;
    }
  }
`

export const Toggle = styled.button`
  cursor: pointer;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: none;
  background-color: ${(props) => props.theme.colors.gray};
  color: ${(props) => props.theme.colors.white};
  /* margin-right: 10px; */
  &:focus {
    outline: none;
  }
  transition: all 0.5s ease;
`
export const BankModalBackground = styled.div`
  width: 85vw;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 12;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100vw;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 80vh;
  }
`
